// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"176":"f9300903","965":"194b979c"}[chunkId] + ".chunk.css";
};